module.exports = __webpack_public_path__ + "static/media/stripe-logo.ec862d62.png";